export enum VopMatchResult {
  Match = 'MATCH',
  NoMatch = 'NO_MATCH',
  CloseMatch = 'CLOSE_MATCH',
}

export interface VopWarningState {
  matchResult: VopMatchResult | null
  suggestedName?: string
  isVerifying: boolean
  error?: string
}
